module.exports = __webpack_public_path__ + "img/rondonia.c5824411.jpg";